"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestBatch = exports.IkeRestBatchControl = void 0;
var tslib_1 = require("tslib");
var deferred_1 = require("./deferred");
var delayed_task_1 = require("./delayed.task");
var IkeRestBatchControl = /** @class */ (function () {
    function IkeRestBatchControl(boundDepartment) {
        this.boundDepartment = boundDepartment;
        this.batches = {};
    }
    IkeRestBatchControl.prototype.batch = function (obj, key, value) {
        var batchKey = "".concat(obj.actionName, ":").concat(key);
        var batch = this.batches[batchKey];
        if (batch == null || batch.executed) {
            this.batches[batchKey] = batch = new IkeRestBatch(this.boundDepartment.query(obj), key);
        }
        return batch.add(value);
    };
    return IkeRestBatchControl;
}());
exports.IkeRestBatchControl = IkeRestBatchControl;
var IkeRestBatch = /** @class */ (function () {
    function IkeRestBatch(query, key) {
        var _this = this;
        this.runner = new delayed_task_1.IkeDelayedTask(function () { return _this.execute(); }, IkeRestBatch.BATCH_DELAY);
        this.query = query;
        this.key = key;
        this.values = {};
    }
    IkeRestBatch.prototype.add = function (value) {
        var existing = this.values[value];
        if (existing == null) {
            if (this.executed) {
                throw new Error('Cannot add to a executed batch');
            }
            existing = this.values[value] = deferred_1.Deferred.create();
        }
        this.runner.delay();
        return existing.promise;
    };
    IkeRestBatch.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var toFetch, queryBatch, _i, queryBatch_1, batch, documents, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.executed = true;
                        toFetch = Object.keys(this.values);
                        queryBatch = [];
                        do {
                            queryBatch.push(toFetch.splice(0, IkeRestBatch.BATCH_SIZE));
                        } while (toFetch.length > 0);
                        _i = 0, queryBatch_1 = queryBatch;
                        _a.label = 1;
                    case 1:
                        if (!(_i < queryBatch_1.length)) return [3 /*break*/, 6];
                        batch = queryBatch_1[_i];
                        this.query.in(this.key, batch);
                        this.query.limit(batch.length);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.query.find()];
                    case 3:
                        documents = _a.sent();
                        this.resolveDocuments(batch, documents);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        batch.map(function (id) { return _this.values[id].reject(e_1); });
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    IkeRestBatch.prototype.resolveDocuments = function (batch, documents) {
        var docMap = {};
        for (var _i = 0, documents_1 = documents; _i < documents_1.length; _i++) {
            var document_1 = documents_1[_i];
            var key = document_1[this.key];
            var deffered = this.values[key];
            docMap[key] = true;
            if (deffered != null) {
                deffered.resolve(document_1);
            }
        }
        if (batch.length === documents.length) {
            return;
        }
        // Resolve null for invalid records
        for (var _a = 0, batch_1 = batch; _a < batch_1.length; _a++) {
            var key = batch_1[_a];
            if (docMap[key]) {
                continue;
            }
            var deffered = this.values[key];
            deffered.resolve(null);
        }
    };
    IkeRestBatch.BATCH_SIZE = 1000;
    IkeRestBatch.BATCH_DELAY = 5;
    return IkeRestBatch;
}());
exports.IkeRestBatch = IkeRestBatch;
//# sourceMappingURL=batch.js.map